import { usePathname } from "next/navigation";
import type { PageParams } from "../app/types";
import { memo } from "../helpers/memo";
import { extractPageParamsFromPathname } from "../helpers/pageParams";
import { useCountry } from "./useCountry";

const memoizedPageParams = memo(extractPageParamsFromPathname);

export const usePageParams = (): PageParams => {
    const pathname = usePathname();
    const country = useCountry();

    return memoizedPageParams(pathname, pathname, country);
};
